import { useCallback, useState } from 'react';
import { StickyNoteContextMenu } from '../Menu/StickyNoteContextMenu';

interface StickyNoteContextMenuState {
  x: number | null;
  y: number | null;
  isOpen: boolean;
  stickyNoteNodeId: string | null;
}

export const useStickyNoteContextMenu = () => {
  const [stickyNoteContextMenu, setStickyNoteContextMenu] = useState<StickyNoteContextMenuState>({
    x: null,
    y: null,
    isOpen: false,
    stickyNoteNodeId: null,
  });

  const openStickyNoteContextMenu = useCallback((x: number, y: number, stickyNoteNodeId: string) => {
    setStickyNoteContextMenu({
      x: x,
      y: y,
      isOpen: true,
      stickyNoteNodeId,
    });
  }, []);

  const closeStickyNoteContextMenu = useCallback(() => {
    setStickyNoteContextMenu((current) => ({ ...current, isOpen: false }));
  }, []);

  const stickyNoteContextMenuComponent =
    stickyNoteContextMenu.isOpen &&
    stickyNoteContextMenu.x !== null &&
    stickyNoteContextMenu.y !== null &&
    stickyNoteContextMenu.stickyNoteNodeId ? (
      <StickyNoteContextMenu
        key="sticky-note-context-menu"
        positionX={stickyNoteContextMenu.x}
        positionY={stickyNoteContextMenu.y}
        isOpen={stickyNoteContextMenu.isOpen}
        onClose={closeStickyNoteContextMenu}
        stickyNoteNodeId={stickyNoteContextMenu.stickyNoteNodeId}
      />
    ) : null;

  return {
    openStickyNoteContextMenu,
    closeStickyNoteContextMenu,
    stickyNoteContextMenuComponent,
  };
};
